/**
 * Map Popup
 */

const CLASSES = {
  BUBBLE_CONTENT: 'map-popup-bubble-content',
  BUBBLE_ANCHOR: 'map-popup-bubble-anchor',
  TIP_ANCHOR: 'map-popup-tip-anchor',
  CLOSE: 'map-popup-close',
};

const createMapPopup = google => {
  return class MapPopup extends google.maps.OverlayView {
    constructor(position, content) {
      super();

      this.position = position;

      content.classList.add(CLASSES.BUBBLE_CONTENT);

      let pixelOffset = document.createElement('div');
      pixelOffset.classList.add(CLASSES.BUBBLE_ANCHOR);
      pixelOffset.appendChild(content);

      this.anchor = document.createElement('div');
      this.anchor.classList.add(CLASSES.TIP_ANCHOR);
      this.anchor.appendChild(pixelOffset);
      this.anchor.style.visibility = 'hidden';

      // Optionally stop clicks, etc., from bubbling up to the map.
      this.stopEventPropagation();
    }

    hide() {
      if (this.anchor) {
        // The visibility property must be a string enclosed in quotes.
        this.anchor.style.visibility = 'hidden';
      }
    }

    show() {
      if (this.anchor) {
        const anchors = document.getElementsByClassName(CLASSES.TIP_ANCHOR);
        for (let i = 0; i < anchors.length; i++) {
          anchors[i].style.visibility = 'hidden';
        }
        this.anchor.style.visibility = 'visible';
      }
    }

    toggle() {
      if (!this.anchor) return;

      if (this.anchor.style.visibility === 'hidden') return this.show();

      return this.hide();
    }

    // Called when the popup is added to the map.
    onAdd() {
      this.getPanes().floatPane.appendChild(this.anchor);
    }

    // Called when the popup is removed from the map.
    onRemove() {
      if (this.anchor.parentElement) {
        this.anchor.parentElement.removeChild(this.anchor);
      }
    }

    /** Called when the popup needs to draw itself. */
    draw() {
      let divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position
      );

      // Hide the popup when it is far out of view.
      let display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? 'block'
          : 'none';

      if (display === 'block') {
        this.anchor.style.left = `${divPosition.x}px`;
        this.anchor.style.top = `${divPosition.y}px`;
      }

      if (this.anchor.style.display !== display) {
        this.anchor.style.display = display;
      }
    }

    /** Stops clicks/drags from bubbling up to the map. */
    stopEventPropagation() {
      let anchor = this.anchor;
      anchor.style.cursor = 'auto';

      let events = [
        'click',
        'dblclick',
        'contextmenu',
        'wheel',
        'mousedown',
        'touchstart',
        'pointerdown',
      ];

      events.forEach(event => {
        anchor.addEventListener(event, e => {
          e.stopPropagation();
        });
      });
    }
  };
};

export default createMapPopup;
